/* eslint-disable no-param-reassign */
const getInitialState = () => ({
  curriculumGoals: {},
  curriculum: undefined,
});

const curriculumSlice = (set, get) => ({
  sliceName: 'curriculum',
  getInitialState,
  selectors: {
    ...getInitialState(),
  },
  mutators: {
    setCurriculumGoals: (data) =>
      set((draft) => {
        draft.curriculumGoals = data.curriculumGoals;
      }),
    setSkeletonCurriculum: (data) =>
      set((draft) => {
        draft.curriculum = data.curriculum;
        if (data.isDecorated) {
          draft.curriculumGoals = data.curriculum.objectives;
        }
      }),
  },
});

export default curriculumSlice;
